import React from "react"
import L10n from "lib/carrot-l10n"
import { FormProvider, useForm } from "react-hook-form"
import { Body, Container, H2 } from "@carrotfertility/carotene"
import { Steps } from "../workflow/steps"
import { useProgressTracker } from "../../views/modal/ProgressTracker"
import { useStateMachine } from "../../context/stateMachine/StateMachineContext"
import useSubmitWithErrorCatch from "../hooks/useSubmitWithErrorCatch"
import {
  BenefitEnrollmentFlowModalBackButton,
  BenefitEnrollmentModalContinueButton,
  BenefitEnrollmentModalFormSelect
} from "../shared"
import { useCurrentUser } from "../../context/user/UserContext"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const FieldName = "areYouLegallyMarriedValue"
const ViewName = Steps.ARE_YOU_LEGALLY_MARRIED

function AreYouLegallyMarriedStep(): JSX.Element {
  useProgressTracker(1, "YOUR INSURANCE COVERAGE")
  const formMethods = useForm()
  const { legallyMarried, updateUserInfo, memberHasLegalPartner } = useCurrentUser()
  const { setNextStep } = useStateMachine(ViewName, legallyMarried)
  useStateMachine(ViewName, memberHasLegalPartner)
  const { onSubmit } = useSubmitWithErrorCatch(async (args) => {
    const val = args[FieldName].id
    val !== "IM_NOT_SURE" &&
      updateUserInfo({
        legallyMarried: val
      })
    setNextStep(ViewName, val)
  })

  const { handleSubmit } = formMethods

  return (
    <FormProvider {...formMethods}>
      <Container padding="none" stack="huge">
        <BenefitEnrollmentFlowModalBackButton />
      </Container>
      <H2 stack="tiny" variant="dark">{l`Are you legally married?`}</H2>
      <Container padding="none" stack="large">
        <Body color="black-80">{l`Your partner's medical coverage can affect how your Carrot benefit is taxed and whether any deductibles apply.`}</Body>
      </Container>
      <Container padding="none" stack="giant">
        <BenefitEnrollmentModalFormSelect
          name={FieldName}
          defaultValue={legallyMarried}
          options={[
            { label: l(`Yes`), id: "true" },
            { label: l(`No`), id: "false" }
          ]}
        />
      </Container>
      <BenefitEnrollmentModalContinueButton onClick={handleSubmit(onSubmit)} />
    </FormProvider>
  )
}

export { AreYouLegallyMarriedStep }
